import getIsEdge from "selectors/device/getIsEdge";
import getIsFirefox from "selectors/device/getIsFirefox";
import getIsIE from "selectors/device/getIsIE";
import { createSelector } from "reselect";

const getNeedsModifiedScrollbars = createSelector(
  [getIsEdge, getIsFirefox, getIsIE],
  (isEdge, isFirefox, isIE) => isEdge || isFirefox || isIE,
);

export default getNeedsModifiedScrollbars;
